import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {maintenanceAPI} from "../api";
import {INewMaintenanceTemplate, IUpdateMaintenanceTemplate} from "../../../models/IMaintenance";

// ── Шаблоны регламентов ───────────────────────────────────────────────────

export const fetchGetAllTemplates = createAsyncThunk(
    "maintenance/get_all_templates",
    async (_, {rejectWithValue}) => {
        try {
            return await maintenanceAPI.getAll();
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchGetActiveTemplates = createAsyncThunk(
    "maintenance/get_active_templates",
    async (_, {rejectWithValue}) => {
        try {
            return await maintenanceAPI.getActive();
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchGetTemplateById = createAsyncThunk(
    "maintenance/get_template_by_id",
    async (id: string, {rejectWithValue}) => {
        try {
            return await maintenanceAPI.getById(id);
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchCreateTemplate = createAsyncThunk(
    "maintenance/create_template",
    async (dto: INewMaintenanceTemplate, {rejectWithValue}) => {
        try {
            return await maintenanceAPI.create(dto);
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchUpdateTemplate = createAsyncThunk(
    "maintenance/update_template",
    async (
        {id, dto}: { id: string; dto: IUpdateMaintenanceTemplate },
        {rejectWithValue},
    ) => {
        try {
            return await maintenanceAPI.update(id, dto);
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchDeleteTemplate = createAsyncThunk(
    "maintenance/delete_template",
    async (id: string, {rejectWithValue}) => {
        try {
            await maintenanceAPI.delete(id);
            return id;
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

// ── Дашборд ТО ────────────────────────────────────────────────────────────

export const fetchGetDashboard = createAsyncThunk(
    "maintenance/get_dashboard",
    async (_, {rejectWithValue}) => {
        try {
            return await maintenanceAPI.getDashboard();
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchGetMaintenanceTasks = createAsyncThunk(
    "maintenance/get_maintenance_tasks",
    async (_, {rejectWithValue}) => {
        try {
            return await maintenanceAPI.getMaintenanceTasks();
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchGetMaintenanceTasksByMachinery = createAsyncThunk(
    "maintenance/get_maintenance_tasks_by_machinery",
    async (machinery_id: string, {rejectWithValue}) => {
        try {
            return await maintenanceAPI.getMaintenanceTasksByMachinery(machinery_id);
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);